import { Camera, ImageIcon, X } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Sheet, SheetContent } from "@/components/ui/sheet";

interface AvatarSourcePickerProps {
  open: boolean;
  onClose: () => void;
  onCamera: () => void;
  onGallery: () => void;
}

const AvatarSourcePicker = ({ open, onClose, onCamera, onGallery }: AvatarSourcePickerProps) => {
  const { t } = useTranslation();
  return (
    <Sheet open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <SheetContent side="bottom" className="rounded-t-2xl pb-8">
        <div className="flex flex-col gap-3 pt-2">
          <button
            type="button"
            onClick={() => { onCamera(); onClose(); }}
            className="flex items-center gap-4 w-full rounded-xl px-4 py-3.5 text-left hover:bg-muted transition-colors"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
              <Camera className="h-5 w-5 text-primary" />
            </span>
            <span className="font-medium text-sm">{t("button.takePhoto")}</span>
          </button>

          <button
            type="button"
            onClick={() => { onGallery(); onClose(); }}
            className="flex items-center gap-4 w-full rounded-xl px-4 py-3.5 text-left hover:bg-muted transition-colors"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
              <ImageIcon className="h-5 w-5 text-primary" />
            </span>
            <span className="font-medium text-sm">{t("avatar.sourcePicker.gallery")}</span>
          </button>

          <button
            type="button"
            onClick={onClose}
            className="flex items-center gap-4 w-full rounded-xl px-4 py-3.5 text-left hover:bg-muted transition-colors text-muted-foreground"
          >
            <span className="flex h-10 w-10 items-center justify-center rounded-full bg-muted">
              <X className="h-5 w-5" />
            </span>
            <span className="font-medium text-sm">{t("button.cancel")}</span>
          </button>
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default AvatarSourcePicker;
